/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './create_application_flow';
import './retrieve_application_flow';
import './update_application_flow';
import './submit_application_flow';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ApplicationFlowService": {
                    "methods": {
                      "CreateApplicationFlow": {
                        "requestType": ".squareup.sfs.external.service.CreateApplicationFlowRequest",
                        "responseType": ".squareup.sfs.external.service.CreateApplicationFlowResponse"
                      },
                      "RetrieveApplicationFlow": {
                        "requestType": ".squareup.sfs.external.service.RetrieveApplicationFlowRequest",
                        "responseType": ".squareup.sfs.external.service.RetrieveApplicationFlowResponse"
                      },
                      "UpdateApplicationFlow": {
                        "requestType": ".squareup.sfs.external.service.UpdateApplicationFlowRequest",
                        "responseType": ".squareup.sfs.external.service.UpdateApplicationFlowResponse"
                      },
                      "SubmitApplicationFlow": {
                        "requestType": ".squareup.sfs.external.service.SubmitApplicationFlowRequest",
                        "responseType": ".squareup.sfs.external.service.SubmitApplicationFlowResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ApplicationFlowService) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPCs for Savings Application Flows
 * --
 *
 * SOURCE ApplicationFlowService @ squareup/sfs/external/services/application_flow/application_flow_service.proto at 14:1
 */
export const ApplicationFlowService = $root.lookupService('squareup.sfs.external.service.ApplicationFlowService');